const scrollDown = document.querySelector('#scroll-down-animation');
const homepageBanner = document.querySelector('#homepageBanner');
const nextSibling = homepageBanner?.nextElementSibling;

scrollDown?.addEventListener('click', scrollDownAnimation);

function scrollDownAnimation(){
  nextSibling?.scrollIntoView({ behavior: 'smooth' });
}